<script setup lang="ts">
  import { Swiper, SwiperSlide } from 'swiper/vue'
  import { Navigation, Pagination } from 'swiper/modules'
  import type { Recipe } from '@/types/Recipe'

  import 'swiper/css'
  import 'swiper/css/navigation'
  import 'swiper/css/pagination'

  const modules = ref([Navigation, Pagination])

  withDefaults(
    defineProps<{
      data: Recipe[]
      autoHeight?: InstanceType<typeof Swiper>['$props']['autoHeight']
      slidesPerView?: InstanceType<typeof Swiper>['$props']['slidesPerView']
      spaceBetween?: InstanceType<typeof Swiper>['$props']['spaceBetween']
      grabCursor?: InstanceType<typeof Swiper>['$props']['grabCursor']
    }>(),
    {
      autoHeight: true,
      slidesPerView: 'auto',
      spaceBetween: 4,
      grabCursor: true,
    },
  )
</script>

<template>
  <ClientOnly>
    <Swiper
      :auto-height="autoHeight"
      :slides-per-view="slidesPerView"
      :space-between="spaceBetween"
      :modules="modules"
      :grab-cursor="grabCursor"
      v-bind="$attrs"
      class="swiper"
    >
      <SwiperSlide v-for="item in data" :key="item.slug as string" class="swiper-item !w-fit">
        <slot :item="item" />
      </SwiperSlide>
    </Swiper>
  </ClientOnly>
</template>
